import { z } from "zod";

export const flightRequestCreationSchema = z.object({
  account: z.any().optional(),
  sucursal: z.any().optional(),
  usuarioMobile: z.any().optional(),
  tipoServicio: z.any().optional(),
  procedencia: z.any().optional(),
  fechaDeseada: z.any().optional(),
  hectareas: z.any().optional(),
  valorUnitario: z.any().optional(),
  valorTotal: z.any().optional(),
  observaciones: z.any().optional(),
});
